<nav class="w-full h-full flex justify-around items-center mb-0 sm:hidden bg-club">
    <ul class="mobile-nav h-full">
        <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <button class="flex flex-col cursor-pointer justify-center items-center"
                    (click)="toggleNavigation('mainNavigation')">
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bars-3-center-left'"></mat-icon>
                <span class="text-white text-xs">Menu</span>
            </button>
        </li>

        <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <a class="flex flex-col cursor-pointer justify-center items-center" [routerLink]="['/journal']"
               routerLinkActive="footer-router-link-active">
                <mat-icon [svgIcon]="'heroicons_outline:fire'"></mat-icon>
                <span class="text-xs">Fil d'actu.</span>
            </a>
        </li>
        <!--!! <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <a
                class="flex flex-col cursor-pointer justify-center items-center"
                [routerLink]="['/products']"
                routerLinkActive="footer-router-link-active"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bolt'"></mat-icon>
                <span class="text-xs">Bons plans</span>
            </a>
        </li>
        <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <a class="flex flex-col cursor-pointer justify-center items-center" [routerLink]="['/match-calendar']"
                routerLinkActive="footer-router-link-active">
                <mat-icon [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                <span class="text-xs">Calendrier</span>
            </a>
        </li>-->
        <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <!-- Si l'utilisateur est uniquement joueur -->
            <ng-container *ngIf="isPlayerOnly">
                <a class="flex flex-col cursor-pointer justify-center items-center"
                   [routerLink]="['/player-profile/' + userId]"
                   routerLinkActive="footer-router-link-active">
                    <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
                    <span class="text-xs">Mon profil joueur</span>
                </a>
            </ng-container>

            <!-- Si l'utilisateur est uniquement parent -->
            <ng-container *ngIf="isParentOnly">
                <button class="flex flex-col cursor-pointer justify-center items-center"
                        (click)="openChildrenProfilesDialog()">
                    <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
                    <span class="text-xs">Profils joueurs</span>
                </button>
            </ng-container>

            <!-- Si l'utilisateur est à la fois parent et joueur -->
            <ng-container *ngIf="isParentAndPlayer">
                <button class="flex flex-col cursor-pointer justify-center items-center"
                        (click)="openProfileSelectionDialog()">
                    <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
                    <span class="text-xs">Mes profils</span>
                </button>
            </ng-container>

            <!-- Si l'utilisateur n'est ni parent ni joueur -->
            <ng-container *ngIf="!isPlayer && !isParent">
                <a class="flex flex-col cursor-pointer justify-center items-center"
                   [routerLink]="['/match-calendar']"
                   routerLinkActive="footer-router-link-active">
                    <mat-icon [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                    <span class="text-xs">Calendrier</span>
                </a>
            </ng-container>
        </li>
        <li class="bloc-icon pb-2 flex flex-col cursor-pointer">
            <a
                class="flex flex-col cursor-pointer justify-center items-center"
                [routerLink]="['/sponsoring']"
                routerLinkActive="footer-router-link-active"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:heart'"
                ></mat-icon>
                <span class="text-xs">Nos Sponsors</span>
            </a>
        </li>
        <mat-divider [vertical]="true" [style.width.px]="2" [style.height.px]="35"
                     class="border-solid border-white shadow-sm shadow-primary"></mat-divider>
        <li class="flex flex-col items-center justify-around mr-3">
            <span class="text-white text-center text-xs whitespace-nowrap">Notre Parrain</span>
            <div class="max-w-18">
                <app-logo-parrain context="footer" [useMainSponsor]="true" customClass="cursor-pointer w-full"
                                  (parrainClicked)="onShowParrainSpace($event)">
                </app-logo-parrain>
            </div>
        </li>
    </ul>
</nav>
